import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Paper,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TabPanel from "../../../component/TabPanel";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import { getIndustryList, getStageList, updateSales } from "../../../api/sales";
import { Controller, useForm } from "react-hook-form";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import ViewCrmLeadsFollowup from "./view.crmleads.followup";
import ViewCrmLeadsContacts from "./view.crmleads.contacts";
import ViewCrmLeadsNotes from "./view.crmleads.notes";
import { deleteCrmLeads, updateCrmLeads } from "../../../api/crmLeads";
import DeleteDialog from "../../../component/DeleteDialogDetailPage";
import { getEmployeeList, getSalesRepList } from "../../../api/employee";
import { getCloudRepList } from "../../../api/cloudRep";
import { CountryCodes } from "../../../countryCodes";
import SearchAndLoadMoreDropdown from "../../../component/SearchAndLoadMoreDropdown";
import { ClearOutlined } from "@mui/icons-material";

export default function ViewCrmLeads({ preloadedValues, refresh }) {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [stageListData, setStageListData] = useState([]);
  const [IndustryListData, setIndustryListData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [cloudRepsList, setCloudRepsList] = useState([]);
  const [cloudRepName, setcloudRepName] = useState(
    preloadedValues.cloud_rep_name
  );
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues: preloadedValues });
  // const cloudRepName = watch("cloud_rep_name");
  useEffect(() => {
    industryList();
    stageList();
    employeeList();
  }, []);
  useEffect(() => {
    cloudRepList();
  }, []);
  async function onSalesUpdate(newdata) {
    if (cloudRepName) {
      newdata.cloud_rep = preloadedValues.cloud_rep;
      delete newdata.cloud_rep_name;
    }
    try {
      const { data } = await updateCrmLeads(params.id, newdata, user.token);
      refresh();
      // loadMasterData();
      dispatch(showAlert(data.msg));
      navigate(-2);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function stageList() {
    try {
      const { data } = await getStageList(user.token);
      setStageListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onDelete = () => {
    deleteCrmLeads(params.id, user.token)
      .then((res) => {
        if (res.data.status == true) {
          navigate("/crmLeads");
          dispatch(showAlert(res.data.msg));
        } else {
          dispatch(showAlert(res.data.msg));
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const employeeList = async () => {
    const token = user.token;
    return await getSalesRepList(
      {
        name: "",
      },
      token
    )
      .then((res) => {
        // const role = "SalesPerson";
        // const filtteredRole = res.data.EmployeeList.filter(
        //   (e) => e.role === role
        // );

        setEmployeesList(res.data.data.SalesRepList);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const cloudRepList = async () => {
    const token = user.token;
    return await getCloudRepList({}, token)
      .then((res) => {
        setCloudRepsList(res.data.data.CloudRep);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSalesUpdate)}
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Grid container spacing={2} sx={{ pt: "1rem" }}>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                required
                fullWidth
                error={Boolean(errors.industry_value)}
              >
                <InputLabel id="demo-simple-select-label-a">
                  Industry
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select value={props.value} onChange={props.onChange}>
                      {IndustryListData.map((c, i) => (
                        <MenuItem key={i} value={c.industry_value}>
                          {c.industry_display_value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="industry_value"
                  control={control}
                  rules={{
                    required: "Please select Industry value",
                  }}
                />
                <FormHelperText>
                  {errors.industry_value?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                required
                fullWidth
                error={Boolean(errors.stage_value)}
              >
                <InputLabel id="demo-simple-select-label-a">Stage</InputLabel>
                <Controller
                  render={(props) => (
                    <Select value={props.value} onChange={props.onChange}>
                      {stageListData.map((s, i) => (
                        <MenuItem key={i} value={s.stage_value}>
                          {s.stage_display}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="stage_value"
                  control={control}
                  rules={{
                    required: "Please select Stage value",
                  }}
                />
                <FormHelperText>{errors.stage_value?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl required fullWidth error={Boolean(errors.priority)}>
                <InputLabel id="demo-simple-select-label-a">
                  Priority
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select value={props.value} onChange={props.onChange}>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                    </Select>
                  )}
                  name="priority"
                  control={control}
                  rules={{
                    required: "Please select priority value",
                  }}
                />
                <FormHelperText>{errors.priority?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth>
                {cloudRepName !== "" ? (
                  <TextField
                    name="cloud_rep_name"
                    fullWidth
                    label="Cloud Rep"
                    type="text"
                    variant="outlined"
                    inputRef={register({
                      required: "Cloud Rep is required.",
                    })}
                    error={Boolean(errors.cloud_rep_name)}
                    helperText={errors.cloud_rep_name?.message}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <ClearOutlined
                          onClick={() => {
                            setcloudRepName(""); // This will clear the value of the cloud_rep field
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      ),
                    }}
                  />
                ) : (
                  <>
                    <Controller
                      name="cloud_rep"
                      control={control}
                      rules={{
                        required: "Please select customer contact.", // Add the validation rule for the required field
                      }}
                      render={(props) => (
                        <SearchAndLoadMoreDropdown
                          value={props.value} // Use optional chaining here to handle the undefined case
                          onValueChange={(data) => {
                            if (data?.id) {
                              const selectedValue = cloudRepsList.find(
                                (c) => c.id === data.id
                              );
                              console.log("selected===", selectedValue);
                              setValue("email", selectedValue?.email);
                              setValue("contact", selectedValue?.contact);
                              setValue("address", selectedValue?.address);
                              setValue(
                                "linkedin_url",
                                selectedValue?.linkedin_url
                              );
                              setValue(
                                "country_code",
                                selectedValue?.country_code
                              );
                              setValue("city", selectedValue?.city);
                              setValue("state", selectedValue?.state);
                              props.onChange(data.id);
                            } else {
                              setValue("cloud_rep", "");
                            }
                          }}
                        />
                      )}
                    />
                    {errors.cloud_rep && (
                      <Typography variant="body1" color="error">
                        {errors.cloud_rep.message}
                      </Typography>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="email"
                fullWidth
                label="Email"
                type="text"
                variant="outlined"
                inputRef={register({
                  // required: false,
                  required: "E-mail is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="linkedin_url"
                fullWidth
                label="LinkedIn URL"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "LinkedIn URL is required.",
                  pattern: {
                    value:
                      /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/,
                    message: "Please enter a valid linkedin url.",
                  },
                })}
                error={Boolean(errors.linkedin_url)}
                helperText={errors.linkedin_url?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                fullWidth
                // required
                error={Boolean(errors.country_code)}
              >
                <InputLabel id="demo-simple-select-label">
                  Country Code
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Country Code"
                      onChange={props.onChange}
                    >
                      {CountryCodes.map((data, key) => (
                        <MenuItem key={key} value={data.code}>
                          +{data.code} {data.country}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="country_code"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: false,
                    // required: "Please select Country Code",
                  }}
                />
                <FormHelperText>{errors.country_code?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="state"
                fullWidth
                label="State"
                type="text"
                inputRef={register({
                  required: false,
                  // required: "State is required.",
                })}
                // required
                error={Boolean(errors.state)}
                helperText={errors.state?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="city"
                fullWidth
                label="City"
                type="text"
                inputRef={register({
                  required: false,
                  // required: "City is required.",
                })}
                // required
                error={Boolean(errors.city)}
                helperText={errors.city?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="contact"
                fullWidth
                label="Contact"
                variant="outlined"
                type="tel"
                inputProps={{ maxLength: 10 }}
                inputRef={register({
                  required: false,
                  validate: (value) => {
                    if (value && value.length < 10) {
                      return "Please enter a valid number";
                    }
                    return true;
                  },
                })}
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="address"
                fullWidth
                label="Address"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Address is required.",
                })}
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth required error={Boolean(errors.sales_rep)}>
                <InputLabel id="demo-simple-select-label">Sales Rep</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Sales Rep"
                      onChange={props.onChange}
                    >
                      {employeesList.map((e, i) => (
                        <MenuItem key={i} value={e.id}>
                          {e.email}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="sales_rep"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please select Sales rep",
                  }}
                />
                <FormHelperText>{errors.sales_rep?.message}</FormHelperText>
              </FormControl>
              {/* <TextField
                name="sales_rep"
                fullWidth
                label="Sales Rep"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Sales Rep is required.",
                })}
                error={Boolean(errors.sales_rep)}
                helperText={errors.sales_rep?.message}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="company_name"
                fullWidth
                label="Company"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Company is required.",
                })}
                error={Boolean(errors.company_name)}
                helperText={errors.company_name?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="designation"
                fullWidth
                label="Designation"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  //required: "Designation is required.",
                })}
                error={Boolean(errors.designation)}
                helperText={errors.designation?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="project_name"
                fullWidth
                label="Project Name"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Project name is required.",
                })}
                error={Boolean(errors.project_name)}
                helperText={errors.project_name?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="project_description"
                fullWidth
                label="Project Description"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Project description is required.",
                })}
                error={Boolean(errors.project_description)}
                helperText={errors.project_description?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="source"
                fullWidth
                label="Source"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "source is required.",
                })}
                error={Boolean(errors.source)}
                helperText={errors.source?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="arr"
                fullWidth
                label="ARR"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Arr is required.",
                })}
                error={Boolean(errors.arr)}
                helperText={errors.arr?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="vendor"
                fullWidth
                label="Vendor"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Vendor is required.",
                })}
                error={Boolean(errors.vendor)}
                helperText={errors.vendor?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="key_stakeholder"
                fullWidth
                label="Key Stakeholder"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "key stakeholder is required.",
                })}
                error={Boolean(errors.key_stakeholder)}
                helperText={errors.key_stakeholder?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="estimated_budget"
                fullWidth
                label="Estimated Budget($)"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Estimated budget is required.",
                })}
                error={Boolean(errors.estimated_budget)}
                helperText={errors.estimated_budget?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="probability"
                fullWidth
                label="Probability"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Probability is required.",
                })}
                error={Boolean(errors.probability)}
                helperText={errors.probability?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                fullWidth
                error={Boolean(errors.estimated_close_date)}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        shouldDisableDate={disablePrevDates(
                          dayjs(new Date()).subtract(1, "days").toJSON()
                        )}
                        label="Estimated Close Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.estimated_close_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: false,
                      // required: "Estimated Close Date is required.",
                    }}
                    name="estimated_close_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>
                  {errors.estimated_close_date?.message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="success_factor"
                fullWidth
                label="Success Factor"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Success Factor is required.",
                })}
                error={Boolean(errors.success_factor)}
                helperText={errors.success_factor?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="sales_rev"
                fullWidth
                label="Sales Rev"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Sales Rev is required.",
                })}
                error={Boolean(errors.sales_rev)}
                helperText={errors.sales_rev?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="cloud_rev"
                fullWidth
                label="Cloud Rev"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Cloud Rev is required.",
                })}
                error={Boolean(errors.cloud_rev)}
                helperText={errors.cloud_rev?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth error={Boolean(errors.created_Date)}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        disabled
                        value={props.value}
                        shouldDisableDate={disablePrevDates(
                          dayjs(new Date()).subtract(1, "days").toJSON()
                        )}
                        label="created_Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.created_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: false,
                      // required: "Estimated Close Date is required.",
                    }}
                    name="created_Date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>{errors.created_date?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="communication"
                fullWidth
                label="Communication"
                multiline={true}
                rows={3}
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Cloud Rev is required.",
                })}
                error={Boolean(errors.communication)}
                helperText={errors.communication?.message}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  disabled={/^Trial_User$/i.test(user.role) ? true : false}
                  variant="contained"
                  // onClick={handleSubmit(onSalesUpdate)}
                  type="submit"
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
                {/* <Button
                variant="contained"
                onClick={() => {
                  setOpen(true);
                }}
                style={{ padding: "5px 7px" }}
              >
                Delete
              </Button> */}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Follow Up"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Contacts"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="notes"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <ViewCrmLeadsFollowup
            leadId={preloadedValues.lead_id}
          ></ViewCrmLeadsFollowup>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <ViewCrmLeadsContacts
            leadId={preloadedValues.lead_id}
          ></ViewCrmLeadsContacts>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Paper>
          <ViewCrmLeadsNotes
            leadId={preloadedValues.lead_id}
          ></ViewCrmLeadsNotes>
        </Paper>
      </TabPanel>
      <DeleteDialog open={open} setOpen={setOpen} onDelete={onDelete} />
    </Box>
  );
}

function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
{
  /* <FormControl required fullWidth error={Boolean(errors.cloud_rep)}>
                <InputLabel id="demo-simple-select-label">
                  Customer Contact
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Customer Contact"
                      onChange={(event) => {
                        const selectedValue = cloudRepsList.find(
                          (c) => c.id === event.target.value
                        );
                        setValue("email", selectedValue?.email);
                        setValue("contact", selectedValue?.contact);
                        setValue("address", selectedValue?.address);
                        setValue("linkedin_url", selectedValue?.linkedin_url);
                        setValue("country_code", selectedValue?.country_code);
                        props.onChange(event.target.value);
                      }}
                    >
                      {cloudRepsList.map((e, i) => (
                        <MenuItem key={i} value={e.id}>
                          {e.email}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="cloud_rep"
                  control={control}
                 
                  rules={{
                    required: "Please select customer contact",
                  }}
                />
                <FormHelperText>{errors.cloud_rep?.message}</FormHelperText>
              </FormControl> */
}
{
  /* <TextField
                name="cloud_rep"
                fullWidth
                label="Cloud Rep"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Cloud Rep is required.",
                })}
                error={Boolean(errors.cloud_rep)}
                helperText={errors.cloud_rep?.message}
              /> */
}
